import { FormQuerySelector } from "@vesatogo/grass-core"
import { FormCard } from "~/components/FormCard"
import SharedEntityGroup from "~/constants/SharedEntityGroup"
import { useAllUsersQuery } from "~/generated/graphql"

type WhoOverseesTradingProps = {
  inputProps: any
  isDisabled: boolean
  isSubmitted?: boolean
}

const srOfficerGroup = ["Sr Officer"]
const jrOfficerGroup = ["Jr Officer"]
const WhoOverseesTrading = ({
  inputProps,
  isDisabled,
}: WhoOverseesTradingProps) => {
  const isPackaging = inputProps("material_kind").value === "packaging"
  return (
    <FormCard title="Who oversees trading">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <FormQuerySelector
          required={true}
          isDisabled={isDisabled}
          label={isPackaging ? "PM Incharge" : "Sr. Officer Name"}
          className={"mb-2"}
          serverSideQuery
          dataHook={useAllUsersQuery}
          variables={{ groups: srOfficerGroup }}
          {...inputProps("officer", {
            group: SharedEntityGroup.KiteUser,
          })}
        />
        {isPackaging ? null : (
          <FormQuerySelector
            required={true}
            isDisabled={isDisabled}
            label="Jr. Officer Name"
            className={"mb-2"}
            serverSideQuery
            dataHook={useAllUsersQuery}
            variables={{ groups: jrOfficerGroup }}
            {...inputProps("junior_officer", {
              group: SharedEntityGroup.KiteUser,
            })}
          />
        )}
      </div>
    </FormCard>
  )
}

export default WhoOverseesTrading
